module.exports = __webpack_public_path__ + "static/media/happy.045bc519.svg";